import { useState, useMemo } from 'react'

const SCHOOLS = [
  {
    id: 1,
    name: 'Ocean City Surf School',
    city: 'Ocean City',
    state: 'NJ',
    beach: 'Ocean City Beach',
    website: '#',
    onWaveSync: false,
  },
  {
    id: 2,
    name: 'Long Beach Island Surf Academy',
    city: 'Ship Bottom',
    state: 'NJ',
    beach: 'LBI Beach',
    website: '#',
    onWaveSync: false,
  },
  {
    id: 3,
    name: 'Montauk Surf Club',
    city: 'Montauk',
    state: 'NY',
    beach: 'Ditch Plains',
    website: '#',
    onWaveSync: false,
  },
  {
    id: 4,
    name: 'Rockaway Beach Surf School',
    city: 'Rockaway Beach',
    state: 'NY',
    beach: 'Rockaway Beach',
    website: '#',
    onWaveSync: false,
  },
  {
    id: 5,
    name: 'Outer Banks Surf Lessons',
    city: 'Kill Devil Hills',
    state: 'NC',
    beach: 'Avalon Pier Beach',
    website: '#',
    onWaveSync: false,
  },
  {
    id: 6,
    name: 'Cape Hatteras Surf Co.',
    city: 'Buxton',
    state: 'NC',
    beach: 'Cape Hatteras',
    website: '#',
    onWaveSync: false,
  },
  {
    id: 7,
    name: 'Virginia Beach Surf School',
    city: 'Virginia Beach',
    state: 'VA',
    beach: '31st Street Beach',
    website: '#',
    onWaveSync: false,
  },
  {
    id: 8,
    name: 'Cocoa Beach Surf Academy',
    city: 'Cocoa Beach',
    state: 'FL',
    beach: 'Lori Wilson Park',
    website: '#',
    onWaveSync: false,
  },
  {
    id: 9,
    name: 'Folly Beach Surf School',
    city: 'Folly Beach',
    state: 'SC',
    beach: 'Folly Beach',
    website: '#',
    onWaveSync: false,
  },
  {
    id: 10,
    name: 'Narragansett Surf & Skate School',
    city: 'Narragansett',
    state: 'RI',
    beach: 'Town Beach',
    website: '#',
    onWaveSync: false,
  },
  {
    id: 11,
    name: "Stacey's Surf Camp",
    city: 'Margate',
    state: 'NJ',
    beach: 'Margate Beach',
    website: '#',
    onWaveSync: true,
  },
]

const STATES = ['All', 'ME', 'MA', 'RI', 'NY', 'NJ', 'DE', 'MD', 'VA', 'NC', 'SC', 'GA', 'FL']

export default function SurfSchoolDirectory() {
  const [query, setQuery] = useState('')
  const [selectedState, setSelectedState] = useState('All')

  const filtered = useMemo(() => {
    const q = query.toLowerCase().trim()
    return SCHOOLS.filter(s => {
      const matchesState = selectedState === 'All' || s.state === selectedState
      const matchesQuery =
        !q ||
        s.name.toLowerCase().includes(q) ||
        s.city.toLowerCase().includes(q) ||
        s.beach.toLowerCase().includes(q)
      return matchesState && matchesQuery
    })
  }, [query, selectedState])

  return (
    <div style={{ minHeight: '100vh', background: '#F0EDE4', fontFamily: "'DM Sans', sans-serif" }}>

      {/* Nav */}
      <header style={{
        background: '#0B1E3D',
        padding: '0 24px',
        height: 56,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'sticky',
        top: 0,
        zIndex: 10,
      }}>
        <a href="/" style={{ display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none' }}>
          <svg width="28" height="28" viewBox="0 0 40 40" fill="none">
            <circle cx="20" cy="20" r="20" fill="#0EAAA4" opacity="0.15" />
            <path d="M6 26 C10 20, 16 16, 20 20 C24 24, 30 20, 34 14" stroke="#0EAAA4" strokeWidth="2.5" strokeLinecap="round" fill="none" />
            <path d="M6 30 C10 24, 16 20, 20 24 C24 28, 30 24, 34 18" stroke="#0EAAA4" strokeWidth="1.5" strokeLinecap="round" fill="none" opacity="0.5" />
          </svg>
          <span style={{ color: '#FDFCFA', fontWeight: 600, fontSize: 16, letterSpacing: '-0.2px' }}>WaveSync</span>
        </a>
        <a
          href="https://wavesync.cloud"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: '#0EAAA4',
            fontSize: 14,
            fontWeight: 500,
            textDecoration: 'none',
            border: '1px solid rgba(14,170,164,0.4)',
            borderRadius: 8,
            padding: '6px 14px',
          }}
        >
          Learn More
        </a>
      </header>

      {/* Hero */}
      <div style={{
        background: 'linear-gradient(160deg, #0B1E3D 0%, #1A6EA8 100%)',
        padding: '48px 24px 40px',
        textAlign: 'center',
        color: '#FDFCFA',
      }}>
        <p style={{ color: '#0EAAA4', fontSize: 13, fontWeight: 600, letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: 12 }}>
          Community Resource
        </p>
        <h1 style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: 'clamp(26px, 5vw, 38px)',
          fontWeight: 900,
          lineHeight: 1.2,
          marginBottom: 12,
        }}>
          East Coast Surf School Directory
        </h1>
        <p style={{ color: 'rgba(253,252,250,0.72)', fontSize: 16, maxWidth: 480, margin: '0 auto' }}>
          Find surf lessons up and down the Atlantic coast — from Maine to Miami.
        </p>
      </div>

      {/* Filters */}
      <div style={{
        background: '#FDFCFA',
        borderBottom: '1px solid rgba(11,30,61,0.08)',
        padding: '16px 24px',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 12,
        alignItems: 'center',
        position: 'sticky',
        top: 56,
        zIndex: 9,
      }}>
        <input
          type="text"
          placeholder="Search by school or location…"
          value={query}
          onChange={e => setQuery(e.target.value)}
          style={{
            flex: '1 1 220px',
            height: 40,
            border: '1px solid rgba(11,30,61,0.15)',
            borderRadius: 8,
            padding: '0 14px',
            fontSize: 14,
            color: '#0B1E3D',
            background: '#fff',
            outline: 'none',
          }}
        />
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {STATES.map(st => (
            <button
              key={st}
              onClick={() => setSelectedState(st)}
              style={{
                height: 32,
                padding: '0 12px',
                borderRadius: 20,
                border: selectedState === st ? 'none' : '1px solid rgba(11,30,61,0.15)',
                background: selectedState === st ? '#0B1E3D' : 'transparent',
                color: selectedState === st ? '#FDFCFA' : '#3A5070',
                fontSize: 13,
                fontWeight: 500,
                cursor: 'pointer',
                transition: 'all 0.15s',
              }}
            >
              {st}
            </button>
          ))}
        </div>
      </div>

      {/* Grid */}
      <main style={{ maxWidth: 1100, margin: '0 auto', padding: '32px 20px 64px' }}>
        {filtered.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '64px 0', color: '#6A8CAA' }}>
            <p style={{ fontSize: 16 }}>No schools found matching your search.</p>
          </div>
        ) : (
          <>
            <p style={{ fontSize: 13, color: '#6A8CAA', marginBottom: 20 }}>
              {filtered.length} {filtered.length === 1 ? 'school' : 'schools'} listed
            </p>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
              gap: 16,
            }}>
              {filtered.map(school => (
                <SchoolCard key={school.id} school={school} />
              ))}
            </div>
          </>
        )}
      </main>

      {/* Footer CTA */}
      <footer style={{
        background: '#0B1E3D',
        color: '#FDFCFA',
        padding: '40px 24px',
        textAlign: 'center',
      }}>
        <p style={{ fontSize: 17, fontWeight: 500, marginBottom: 8 }}>
          Are you a surf school owner?
        </p>
        <p style={{ color: 'rgba(253,252,250,0.6)', fontSize: 14, marginBottom: 24, maxWidth: 420, margin: '0 auto 24px' }}>
          List your school free — or run your whole operation on WaveSync: scheduling, waivers, instructor management, and more.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <a
            href="https://wavesync.cloud"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              background: '#0EAAA4',
              color: '#fff',
              padding: '10px 22px',
              borderRadius: 8,
              textDecoration: 'none',
              fontSize: 14,
              fontWeight: 600,
            }}
          >
            Learn about WaveSync
          </a>
          <a
            href="mailto:hello@wavesync.cloud"
            style={{
              border: '1px solid rgba(253,252,250,0.25)',
              color: 'rgba(253,252,250,0.8)',
              padding: '10px 22px',
              borderRadius: 8,
              textDecoration: 'none',
              fontSize: 14,
              fontWeight: 500,
            }}
          >
            Add my school
          </a>
        </div>
        <p style={{ marginTop: 32, fontSize: 12, color: 'rgba(253,252,250,0.3)' }}>
          © {new Date().getFullYear()} WaveSync · wavesync.cloud
        </p>
      </footer>
    </div>
  )
}

function SchoolCard({ school }) {
  return (
    <div style={{
      background: '#FDFCFA',
      borderRadius: 12,
      padding: '20px',
      boxShadow: '0 2px 12px rgba(11,30,61,0.07)',
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      border: school.onWaveSync ? '1px solid rgba(14,170,164,0.25)' : '1px solid transparent',
      transition: 'box-shadow 0.2s',
    }}>
      {/* Top row */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
        <div>
          <h2 style={{ fontSize: 16, fontWeight: 600, color: '#0B1E3D', lineHeight: 1.3, marginBottom: 4 }}>
            {school.name}
          </h2>
          <p style={{ fontSize: 13, color: '#6A8CAA' }}>
            {school.beach} · {school.city}, {school.state}
          </p>
        </div>
        <span style={{
          background: '#E8F4F4',
          color: '#3A5070',
          fontSize: 12,
          fontWeight: 600,
          padding: '3px 8px',
          borderRadius: 6,
          whiteSpace: 'nowrap',
          flexShrink: 0,
        }}>
          {school.state}
        </span>
      </div>

      {/* WaveSync badge */}
      {school.onWaveSync && (
        <div style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 5,
          background: 'rgba(14,170,164,0.08)',
          border: '1px solid rgba(14,170,164,0.3)',
          borderRadius: 20,
          padding: '3px 10px',
          width: 'fit-content',
        }}>
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
            <circle cx="5" cy="5" r="5" fill="#0EAAA4" opacity="0.2" />
            <circle cx="5" cy="5" r="3" fill="#0EAAA4" />
          </svg>
          <span style={{ fontSize: 11, fontWeight: 600, color: '#0EAAA4', letterSpacing: '0.3px' }}>
            Books with WaveSync
          </span>
        </div>
      )}

      {/* CTA */}
      <a
        href={school.website}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          marginTop: 'auto',
          display: 'block',
          textAlign: 'center',
          background: '#0B1E3D',
          color: '#FDFCFA',
          padding: '9px 0',
          borderRadius: 8,
          fontSize: 13,
          fontWeight: 500,
          textDecoration: 'none',
        }}
      >
        Visit Website
      </a>
    </div>
  )
}
